import _ from 'lodash';
import assert from 'assert';

export const detectSplitView = e => {
  var req = function(node) {
    if (!node) {
      return false;
    }
    var classlist = node.classList;
    if (
      (classlist && classlist.contains('sys-splitview-1')) ||
      (classlist && classlist.contains('sys-splitview-2'))
    ) {
      return _.filter(classlist, function(c) {
        return c.match(/sys-splitview-(1|2)/i);
      });
    }
    return req(node.parentNode);
  };
  var view = req(e.target);
  if (view && view.length) {
    return view[0].match(/sys-splitview-(1|2)/i)[1];
  }
  return false;
};

/**
 * vwの値からLeftSide RightSide の値を返す
 * @param {String} vw
 * @returns {String} LeftSide RightSide
 */
export const positionKeyFromVw = vw => {
  assert(['1', '2'].includes(vw), `vw=${vw}`);
  if (vw === '1') {
    return 'Left';
  } else if (vw === '2') {
    return 'Right';
  }
};



// WEBPACK FOOTER //
// ./src/utilities/splitViewUtil.js